import {debounce} from '@utils/debounce';

const bodyElement = document.querySelector("body")!;
const header = document.querySelector(".header") as HTMLElement;
let lastScroll = 0;

function clearHeaderFixed(): void {
    header.classList.remove("header--fixed", "header--hide", "header--animate", "header--initialized");
    bodyElement.classList.remove("padding-top");
}

function makeHeaderFixed(hideSticky: boolean = false): void {
    header.classList.add("header--fixed");
    const isInitialized = header.classList.contains("header--initialized");

    if (isInitialized) {
        header.classList.add("header--animate");
    } else {
        header.classList.remove("header--animate");
    }

    // Toggle header visibility
    header.classList.toggle("header--hide", hideSticky);

    bodyElement.classList.add("padding-top");

    // Mark header as initialized
    if (!isInitialized) {
        header.classList.add("header--initialized");
    }
}

const toggleHeaderFixed = debounce((): void => {
  if (document.body.classList.contains("menu-open")) {
    // Do not change header state when menu is open
    return;
  }

  const scrollY = window.scrollY;
  const headerHeight = header.offsetHeight; // Always get the latest height

  // Only reset when the user is at the absolute top
  if (scrollY === 0) {
    clearHeaderFixed();
    return;
  }

  const isScrollingDown = scrollY > lastScroll;
  const isScrollingUp = scrollY < lastScroll;

  // Ensure the header does not become fixed until fully scrolled past
  if (scrollY > headerHeight) {
    if (isScrollingDown) {
      makeHeaderFixed(true); // Hide header on scroll down
    } else if (isScrollingUp) {
      makeHeaderFixed(false); // Show header on scroll up
    }
  }

  lastScroll = scrollY;
}, 10);

window.addEventListener("scroll", toggleHeaderFixed);

document.querySelector(".breadcrumbs__ellipsis")?.addEventListener("click", () => {
    document.querySelector(".breadcrumbs")?.classList.toggle("breadcrumbs--open");
});